import { Record as record, List } from 'immutable';

import trainTime from '../lib/TrainTime';
import { construct, resolve, fields } from '../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../helpers/Records';
import { TicketOfficeHours, BusinessDays } from '../constants/AppConstants';

import OpeningHours from './OpeningHours';

const fieldSchema = {
    crs: [ fields.string ],
    openingHours: [ resolve.as(OpeningHours) ]
};

export default class TicketOffice extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(TicketOffice, json, getResolvers(fieldSchema));
    }

    getOpenStatus(time = trainTime()) {
        const dayOfWeek = time.format('dddd');
        const todayHours = this.openingHours.get(dayOfWeek.toLowerCase());

        const timeWithinTimeSlot = (t, slot) => {
            const openingTime = trainTime(slot.get('startTime'), "HH:mm").day(dayOfWeek);
            let closingTime = trainTime(slot.get('endTime'), "HH:mm").day(dayOfWeek);
            if (closingTime && closingTime.isBefore(trainTime(TicketOfficeHours.CLOSING_CUT_OFF, "HH:mm").day(dayOfWeek))) {
                closingTime = closingTime.add(1, 'day');
            }
            return t.isAfter(openingTime) && t.isBefore(closingTime);
        };

        return todayHours.size
            ? todayHours.some(timeSlot => timeWithinTimeSlot(time, timeSlot))
                ? TicketOfficeHours.OPEN : TicketOfficeHours.CLOSED
                : TicketOfficeHours.NOT_AVAILABLE;
    }

    hasNoHours () {
        return !this.openingHours.toList().some(day => day.size);
    }

    getOpeningHours () {
        return this.openingHours;
    }

    getDailyHours (dayOfWeek) {
        return this.getOpeningHours()[dayOfWeek];
    }

    getDailyOpeningDuration (dayOfWeek) {
        let hours = 0;
        this.getDailyHours(dayOfWeek).forEach(slot => {
            const openingTime = trainTime(slot.get('startTime'), "HH:mm").day(dayOfWeek);
            let closingTime = trainTime(slot.get('endTime'), "HH:mm").day(dayOfWeek);
            if (closingTime && closingTime.isBefore(trainTime(TicketOfficeHours.CLOSING_CUT_OFF, "HH:mm").day(dayOfWeek))) {
                closingTime = closingTime.add(1, 'day');
            }
            hours += closingTime ? closingTime.calendarDuration(openingTime).asHours() : 0;
        });
        return hours;
    }

    isOpenOnBusinessDays (minHours = 3) {
        const isOpenOnBusinessDays = BusinessDays.reduce((isOpen, dayOfWeek) => {
            return isOpen.push(this.getDailyOpeningDuration(dayOfWeek) >= minHours);
        }, new List());
        return !isOpenOnBusinessDays.contains(false);
    }
}
